/**
 * SubmissionErinnernDialog — optional Nachricht + «Erinnerung senden» (P2 Placement Slice 8).
 */

import { useState } from 'react';
import { Dialog } from '../administration/components';
import { Button } from '../../components/ui/Button';

export function SubmissionErinnernDialog({
  open,
  onClose,
  carrierName,
  pending,
  onSubmit,
}: {
  open: boolean;
  onClose: () => void;
  carrierName: string;
  pending: boolean;
  onSubmit: (nachricht: string) => void;
}) {
  const [nachricht, setNachricht] = useState('');
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={`Erinnerung an ${carrierName}`}
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onClose}>
            Abbrechen
          </Button>
          <Button disabled={pending} onClick={() => onSubmit(nachricht.trim())} data-testid="sub-erinnern-submit">
            {pending ? 'Wird gesendet …' : 'Erinnerung senden'}
          </Button>
        </div>
      }
    >
      <label className="flex flex-col gap-1 text-sm">
        <span className="text-muted-foreground">Zusätzliche Nachricht (optional)</span>
        <textarea
          className="min-h-[88px] rounded-md border border-border bg-background p-2 text-sm"
          value={nachricht}
          maxLength={2000}
          onChange={(e) => setNachricht(e.target.value)}
          data-testid="sub-erinnern-nachricht"
        />
      </label>
    </Dialog>
  );
}
